export const EDUCATOR_ROLES = [
  {
    label: "Teacher",
    value: "teacher",
  } as const,
  {
    label: "Teaching Assistant",
    value: "teachingAssistant",
  } as const,
  {
    label: "Librarian",
    value: "librarian",
  } as const,
  {
    label: "Language Specialist",
    value: "languageSpecialist",
  } as const,
  {
    label: "Media Specialist",
    value: "mediaSpecialist",
  } as const,
  {
    label: "Other",
    value: "other",
  } as const,
];

export const SCHOOL_GRADES_WITH_SPECIALISTS = [
  {
    value: 0,
    label: "Kindergarten",
  } as const,
  {
    value: 1,
    label: "1st Grade",
  } as const,
  {
    value: 2,
    label: "2nd Grade",
  } as const,
  {
    value: 3,
    label: "3rd Grade",
  } as const,
  {
    // has to be undefined as opposed to null to satisfy <option>
    value: undefined,
    label: "Librarian, Specialist, or Other",
  } as const,
] as const;

export const GRADE_REQUIRED_VALIDATION_MESSAGE =
  "Please tell us what grade your reader is in.";

export const SCHOOL_GRADES = [
  {
    value: -1,
    label: "Preschool",
  } as const,
  {
    value: 0,
    label: "Kindergarten",
  } as const,
  {
    value: 1,
    label: "1st Grade",
  } as const,
  {
    value: 2,
    label: "2nd Grade",
  } as const,
  {
    value: 3,
    label: "3rd Grade",
  } as const,
  {
    value: 4,
    label: "4th Grade",
  } as const,
  {
    value: 5,
    label: "5th Grade",
  } as const,
  {
    value: 6,
    label: "6th Grade",
  } as const,
  {
    value: 7,
    label: "7th Grade",
  } as const,
  {
    value: 8,
    label: "8th Grade",
  } as const,
  {
    value: 9,
    label: "9th Grade",
  } as const,
  {
    value: 10,
    label: "10th Grade",
  } as const,
  {
    value: 11,
    label: "11th Grade",
  } as const,
  {
    value: 12,
    label: "12th Grade",
  } as const,
] as const;

export type SchoolGrades = typeof SCHOOL_GRADES;
export type SchoolGradesKey = number;
export type SchoolGradesValue =
  | SchoolGrades[SchoolGradesKey]["value"]
  | `${SchoolGrades[SchoolGradesKey]["value"]}`;
export type SchoolGradesLabel = SchoolGrades[SchoolGradesKey]["label"];

export const isGradeLevelKey = (n: unknown): n is SchoolGradesValue => {
  if (typeof n === "string") {
    return n in SCHOOL_GRADE_DICTIONARY;
  } else if (typeof n === "number") {
    return n.toString() in SCHOOL_GRADE_DICTIONARY;
  } else {
    return false;
  }
};

export const SCHOOL_GRADE_DICTIONARY = Object.fromEntries(
  SCHOOL_GRADES.map((x) => [x.value, x.label])
) as Record<SchoolGradesValue, SchoolGradesLabel>;
